import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import luckyWinnerRewardsModel from "@/models/lucky-winner/lucky-winner-rewards"
import router from "@/router"
import store from "@/store"
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable"
import usePagination from "@/views/components/pagination/usePagination"
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api"

export default function useLuckyWinnerRewardList() {
  const { createRewards, editRewards, fetchRewardsListByCampaign, fetchRewardsListByRound, createDuplicateRewards } = luckyWinnerRewardsModel()

  const { pagination, onPageChange, onFilterEntity } = usePagination()
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal()

  const loading = reactive({
    tableData: false,
  })

  const campaignId = ref(null)
  const roundId = ref(null)

  const fields = [
    { key: "seq", label: "No" },
    { key: "image_url", label: "Image" },
    { key: "name", label: "Name" },
    { key: "value", label: "Value" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ]

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ])

  const status = ref(0)

  const rewardListTable = reactive({
    payload: [],
  })

  const rewardTable = ref(null)

  const fetchLuckyWinnerRewardList = () => {
    loading.tableData = true
    fetchRewardsListByRound.payload.CampaignId = campaignId.value
    fetchRewardsListByRound.payload.RoundId = roundId.value
    fetchRewardsListByRound.payload.Page = pagination.currentPage
    fetchRewardsListByRound.payload.Limit = pagination.perPage
    fetchRewardsListByRound.payload.Filters = filters
    store
      .dispatch('api/apiRequest', fetchRewardsListByRound)
      .then(response => {
        if(response.status == "success") {
          rewardListTable.payload = response.data.resp.map((item) => ({
            seq: item.id,
            image_url: item.imageurl,
            name: item.rewards_name,
            value: item.amount,
            _showDetails: false,
            ref: item.reward_ref,
            status: item.status
          }))
          pagination.rows = response.data.resp.length
          pagination.totalRows = response.data.filtered_record??response.data.resp.length
        }
    })
    .catch(error => {
      openDefaultErrorModal(error)
    })
    .finally(() => {
      loading.tableData = false
    })
  }

  const onToggleStatus = (status, reward) => {
    reward.status = !reward.status
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        rewardTable.value.clearSelected()
        fetchLuckyWinnerRewardList()
      }
    },
    { deep: true }
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      rewardTable.value.clearSelected()
      fetchLuckyWinnerRewardList()
    },
    { deep: true }
  )

  const onRewardSelected = (rows) => {
    rewardListTable.payload.forEach((reward) => {
      reward._showDetails = false
      console.log('reward: ', reward)
    })
    if (rows.length) {
      rows[0]._showDetails = !rows[0]._showDetails
    }
  }

  onBeforeMount(() => {
    campaignId.value = router.currentRoute.params.campaignId
    roundId.value = router.currentRoute.params.roundId

    fetchLuckyWinnerRewardList()
  })

  return {
    campaignId,
    roundId,
    rewardTable,
    fields,
    loading,
    statusOption,
    status,
    rewardListTable,
    pagination,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
    onRewardSelected,
    onToggleStatus,
  }
}
